// ===============================
// Salepify Free Gift — Custom Logic
// ===============================

async function handleOpenPopup() {
    const offer = window.tlFreeGiftOffer;
    if (!offer?.popupWidget) return;

    const { eligibleOtherRules } = await offer.checkAllRule();
    const { POPUP_LAYOUT } = offer.constants;

    const isGiftOnly = offer.popupWidget.layout === POPUP_LAYOUT.GIFTS_ONLY;

    // Chỉ show khi GIFTS_ONLY
    if (!isGiftOnly) return;

    const rule = eligibleOtherRules.find(({ rule }) => {
        if (rule.auto_add_gift) return false;
        if (!rule.widget?.popup) return false;
        if (offer.template === "cart" && !rule.show_on_pages) return false;
        return true;
    });

    if (rule) {
        offer.popupWidget.showOffer(rule.rule, rule.canClaimCount);
        offer.popupWidget.showModal();
    }
}

// ===============================
// Gắn sự kiện click vào cart drawer
// ===============================
const intervalCart = setInterval(() => {
    const cartLi = document.querySelector(
        'li.header__utils-item.header__utils-item--cart.header__utils-item--mobile'
    );
    if (!cartLi) return;

    clearInterval(intervalCart);
    cartLi.addEventListener('click', handleOpenPopup);
    console.log("✅ Salepify free gift: cart drawer click listener attached");
}, 50);
setTimeout(() => clearInterval(intervalCart), 5000);

// ===============================
// Override showPopupOffer
// ===============================
const intervalPopup = setInterval(() => {
    const offer = window.tlFreeGiftOffer;
    if (!offer?.popupWidget) return;

    clearInterval(intervalPopup);

    const originalShow = offer.showPopupOffer;

    offer.showPopupOffer = async function (...args) {
        const { POPUP_LAYOUT } = offer.constants;
        const layout = offer.popupWidget.layout;

        // Chặn auto popup GIFTS_ONLY nếu không ở cart page
        if (layout === POPUP_LAYOUT.GIFTS_ONLY && offer.template !== "cart") return;

        return originalShow.apply(this, args);
    };

    console.log("✅ Salepify free gift: showPopupOffer overridden");
}, 50);


setTimeout(() => clearInterval(intervalPopup), 3000);
